var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"is-small"},[_c('div',{staticClass:"container"},[_c('ui-page-hero',{attrs:{"id":"id_title_channel","title":'Invoices'}}),_c('Invoices')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }